module.exports = __webpack_public_path__ + "img/art-rule-bg.210c9025.png";